import { Injectable, Input } from '@angular/core';

export interface NavigationItem {
  task: string;
  id: string;
  title: string;
  type: 'item' | 'collapse' | 'group';
  translate?: string;
  icon?: string;
  hidden?: boolean;
  url?: string;
  classes?: string;
  exactMatch?: boolean;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
  function?: any;
  badge?: {
    title?: string;
    type?: string;
  };
  children?: Navigation[];
}

export interface Navigation extends NavigationItem {
  children?: NavigationItem[];

}

const NavigationItemsContisoftPannel = [
  {
    id: 'trackpayout',
    // title: 'Trackpayout',
    type: 'group',
    icon: 'feather icon-monitor',
    children: [
      {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-home',
        children: [
          {
            id: 'standard',
            title: 'Standard',
            type: 'item',
            url: '/trackpayout/dashboard/standard',
          },
          {
            id: 'amount',
            title: 'By Amount',
            type: 'item',
            url: '/trackpayout/dashboard/amount',
          },
          {
            id: 'invoices',
            title: 'By Invoices',
            type: 'item',
            url: '/trackpayout/dashboard/invoice',
          },
          {
            id: 'Outstanding Summary',
            title: 'Outstanding Summary',
            type: 'item',
            url: '/trackpayout/OutstandingReport',
          },
          // {
          //   id: 'analysis-report',
          //   title: 'Analysis Report',
          //   type: 'item',
          //   url: '/trackpayout/dashboard/analysis-report',
          // },
        ]
      },
      {
        id: 'invoice',
        title: 'Invoice',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-plus',
        url: '/trackpayout/invoice/create',
      },
      {
        id: 'push-invoice',
        title: 'Invoice Submission',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-thumbs-up',
        url: '/trackpayout/pushinvoice',
      },
      {
        id: 'report',
        title: 'Reports',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-file-text',
        children: [
          {
            id: 'statement',
            title: 'Ledger Statement',
            type: 'item',
            url: '/trackpayout/report/statement',
          },
          {
            id: 'all',
            title: 'All Invoices',
            type: 'item',
            url: '/trackpayout/report/all',
          },
          // {
          //   id: 'indue',
          //   title: 'Due Invoices',
          //   type: 'item',
          //   url: '/trackpayout/report/indue',
          // },
          // {
          //   id: 'overdue',
          //   title: 'Overdue Invoices',
          //   type: 'item',
          //   url: '/trackpayout/report/overdue',
          // },
          {
            id: 'paid',
            title: 'Paid Invoices',
            type: 'item',
            url: '/trackpayout/report/paid',
          },
          {
            id: 'payment-receipts',
            title: 'Payment Receipts',
            type: 'item',
            url: '/trackpayout/report/payment-receipts',
          },
          {
            id: 'payment-updation',
            title: 'Update Payment',
            type: 'item',
            url: '/trackpayout/report/payment-updation',
          },
          {
            id: 'unpaid',
            title: 'Unpaid Invoices',
            type: 'item',
            url: '/trackpayout/report/unpaid',
          },
          {
            id: 'byduedays',
            title: 'By Due Days',
            type: 'collapse',
            classes: 'nav-item',
            children: [
              {
                id: 'todays',
                // tslint:disable-next-line: quotemark
                title: "Today's Payment",
                type: 'item',
                url: '/trackpayout/report/byduedays/todays',
              },
              {
                id: '7days',
                title: '7 Days',
                type: 'item',
                url: '/trackpayout/report/byduedays/7',
              },
              {
                id: '15days',
                title: '15 Days',
                type: 'item',
                url: '/trackpayout/report/byduedays/15',
              },
              {
                id: '30days',
                title: '30 Days',
                type: 'item',
                url: '/trackpayout/report/byduedays/30',
              },
              {
                id: '60days',
                title: '60 Days',
                type: 'item',
                url: '/trackpayout/report/byduedays/60',
              },
              {
                id: '90days',
                title: '90 Days',
                type: 'item',
                url: '/trackpayout/report/byduedays/90',
              },
              {
                id: 'toofar',
                title: 'Too Far',
                type: 'item',
                url: '/trackpayout/report/byduedays/toofar',
              },
            ]
          },
          {
            id: 'bymasters',
            title: 'By Masters',
            type: 'collapse',
            classes: 'nav-item',
            children: [
              {
                id: 'acmanager',
                // tslint:disable-next-line: quotemark
                title: "By Account Manager",
                type: 'item',
                url: '/trackpayout/report/bymasters/acmanager',
              },
              {
                id: 'category',
                title: 'By Category',
                type: 'item',
                url: '/trackpayout/report/bymasters/category',
              },
              {
                id: 'customer',
                title: 'By Customer',
                type: 'item',
                url: '/trackpayout/report/bymasters/customer',
              },
              {
                id: 'location',
                title: 'By Location',
                type: 'item',
                url: '/trackpayout/report/bymasters/location',
              },
            ]
          },
          {
            id: 'canceled',
            title: 'Inv. Cancelation Report',
            type: 'item',
            url: '/trackpayout/report/cancelation-report',
          },
        ]
      },
      {
        id: 'ageing',
        title: 'Ageing Report',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-clock',
        url: '/trackpayout/report/ageing',
      },
      {
        id: 'reminder',
        title: 'Reminder',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-bell-off',
        url: '/trackpayout/reminder',
      },
      {
        id: 'followup',
        title: 'Mail Follow Up',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-mail',
        url: '/trackpayout/followup',
      },
      {
        id: 'invoicefollowup',
        title: 'Follow Up Module',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-clock',
        url: '/trackpayout/InvoiceFollowup',
      },
      {
        id: 'clinets-performance',
        title: 'Clients Performance',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-activity',
        url: '/trackpayout/clients',
      },
      {
        id: 'task',
        title: 'Task',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-clock',
        url: '/trackpayout/task',
        badge: { type: 'badge badge-pill badge-danger', title: '5' }
      },
      {
        id: 'bill-discount',
        title: 'Bill Discount',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-clipboard',
        url: '/trackpayout/bill-discount',
      },
      {
        id: 'statutory',
        title: 'Statutory',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-clipboard',
        children: [
          {
            id: 'msme',
            title: 'MSME',
            type: 'item',
            url: '/trackpayout/administrator/statutory/msme',
          },
          {
            id: 'gst',
            title: 'GST',
            type: 'item',
            url: '/trackpayout/administrator/statutory/gst',
          }
        ]
      },
      {
        id: 'administrator',
        title: 'Administrator',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-settings',
        children: [
          {
            id: 'acmanager',
            title: 'Account Manager',
            type: 'item',
            url: '/trackpayout/administrator/acmanager',
          },
          {
            id: 'bankdetails',
            title: 'Bank Details',
            type: 'item',
            url: '/trackpayout/administrator/bankdetails',
          },
          {
            id: 'category',
            title: 'Category',
            type: 'item',
            url: '/trackpayout/administrator/category',
          },
          {
            id: 'company',
            title: 'Company',
            type: 'item',
            url: '/trackpayout/administrator/company',
          },
          {
            id: 'customer',
            title: 'Customer',
            type: 'item',
            url: '/trackpayout/administrator/customer',
          },
          {
            id: 'user',
            title: 'User',
            type: 'item',
            url: '/trackpayout/administrator/user',
          },
          {
            id: 'enablenotification',
            title: 'Enable Notification',
            type: 'item',
            url: '/trackpayout/administrator/enablenotification',
          },
        ]
      },
      {
        id: 'contisoftpannel',
        title: 'Contisoft Pannel',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-clipboard',
        children: [
          {
            id: 'dashboard',
            title: 'Dashboard',
            type: 'item',
            url: '/trackpayout/contisoftpannel/dashboard',
          },
          {
            id: 'subscriptions',
            title: 'Subscriptions',
            type: 'item',
            url: '/trackpayout/contisoftpannel/customer',
          },
          {
            id: 'companies',
            title: 'Companies',
            type: 'item',
            url: '/trackpayout/contisoftpannel/company',
          },
        ]
      },
      {
        id: 'log',
        title: 'Log',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-clipboard',
        children: [
          {
            id: 'alllog',
            title: 'Logs',
            type: 'item',
            url: '/trackpayout/log/all',
          },
          {
            id: 'logbyuser',
            title: 'Logs by User',
            type: 'item',
            url: '/trackpayout/log/byuser',
          },
        ]
      },
    ]
  },
];

const NavigationItemsAdmin = [
  {
    id: 'trackpayout',
    // title: 'Trackpayout',
    type: 'group',
    icon: 'feather icon-monitor',
    children: [
      {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-home',
        children: [
          {
            id: 'standard',
            title: 'Standard',
            type: 'item',
            url: '/trackpayout/dashboard/standard',

          },
          {
            id: 'amount',
            title: 'By Amount',
            type: 'item',
            url: '/trackpayout/dashboard/amount',
          },
          {
            id: 'invoices',
            title: 'By Invoices',
            type: 'item',
            url: '/trackpayout/dashboard/invoice',
          },
          {
            id: 'Outstanding Summary',
            title: 'Outstanding Summary',
            type: 'item',
            url: '/trackpayout/OutstandingReport',
          },
          // {
          //   id: 'analysis-report',
          //   title: 'Analysis Report',
          //   type: 'item',
          //   url: '/trackpayout/dashboard/analysis-report',
          // },
        ]
      },
      {
        id: 'invoice',
        title: 'Invoice',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-plus',
        url: '/trackpayout/invoice/create',
      },
      {
        id: 'push-invoice',
        title: 'Invoice Submission',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-thumbs-up',
        url: '/trackpayout/pushinvoice',
      },
      {
        id: 'report',
        title: 'Reports',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-file-text',
        children: [
          // {
          //   id: 'statement',
          //   title: 'Ledger Statement',
          //   type: 'item',
          //   url: '/trackpayout/report/statement',
          // },
          {
            id: 'all',
            title: 'All Invoices',
            type: 'item',
            url: '/trackpayout/report/all',
          },
          // {
          //   id: 'indue',
          //   title: 'Due Invoices',
          //   type: 'item',
          //   url: '/trackpayout/report/indue',
          // },
          // {
          //   id: 'overdue',
          //   title: 'Overdue Invoices',
          //   type: 'item',
          //   url: '/trackpayout/report/overdue',
          // },
          {
            id: 'paid',
            title: 'Paid Invoices',
            type: 'item',
            url: '/trackpayout/report/paid',
          },
          {
            id: 'payment-receipts',
            title: 'Payment Receipts',
            type: 'item',
            url: '/trackpayout/report/payment-receipts',
          },
          {
            id: 'payment-updation',
            title: 'Update Payment',
            type: 'item',
            url: '/trackpayout/report/payment-updation',
          },
          {
            id: 'unpaid',
            title: 'Unpaid Invoices',
            type: 'item',
            url: '/trackpayout/report/unpaid',
          },
          {
            id: 'byduedays',
            title: 'By Due Days',
            type: 'collapse',
            classes: 'nav-item',
            children: [
              {
                id: 'todays',
                // tslint:disable-next-line: quotemark
                title: "Today's Payment",
                type: 'item',
                url: '/trackpayout/report/byduedays/todays',
              },
              {
                id: '7days',
                title: '7 Days',
                type: 'item',
                url: '/trackpayout/report/byduedays/7',
              },
              {
                id: '15days',
                title: '15 Days',
                type: 'item',
                url: '/trackpayout/report/byduedays/15',
              },
              {
                id: '30days',
                title: '30 Days',
                type: 'item',
                url: '/trackpayout/report/byduedays/30',
              },
              {
                id: '60days',
                title: '60 Days',
                type: 'item',
                url: '/trackpayout/report/byduedays/60',
              },
              {
                id: '90days',
                title: '90 Days',
                type: 'item',
                url: '/trackpayout/report/byduedays/90',
              },
              {
                id: 'toofar',
                title: 'Too Far',
                type: 'item',
                url: '/trackpayout/report/byduedays/toofar',
              },
            ]
          },
          {
            id: 'bymasters',
            title: 'By Masters',
            type: 'collapse',
            classes: 'nav-item',
            children: [
              {
                id: 'acmanager',
                // tslint:disable-next-line: quotemark
                title: "By Account Manager",
                type: 'item',
                url: '/trackpayout/report/bymasters/acmanager',
              },
              {
                id: 'category',
                title: 'By Category',
                type: 'item',
                url: '/trackpayout/report/bymasters/category',
              },
              {
                id: 'customer',
                title: 'By Customer',
                type: 'item',
                url: '/trackpayout/report/bymasters/customer',
              },
              {
                id: 'location',
                title: 'By Location',
                type: 'item',
                url: '/trackpayout/report/bymasters/location',
              },
            ]
          },
          {
            id: 'canceled',
            title: 'Inv. Cancelation Report',
            type: 'item',
            url: '/trackpayout/report/cancelation-report',
          },
        ]
      },
      {
        id: 'ageing',
        title: 'Ageing Report',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-clock',
        url: '/trackpayout/report/ageing',
      },
      {
        id: 'reminder',
        title: 'Reminder',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-bell-off',
        url: '/trackpayout/reminder',
      },
      {
        id: 'followup',
        title: 'Mail Follow Up',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-mail',
        url: '/trackpayout/followup',
      },
      {
        id: 'invoicefollowup',
        title: 'Follow Up Module',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-clock',
        url: '/trackpayout/InvoiceFollowup',
      },
      {
        id: 'clinets-performance',
        title: 'Clients Performance',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-activity',
        url: '/trackpayout/clients',
      },
      {
        id: 'task',
        title: 'Task',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-clock',
        url: '/trackpayout/task',
        badge: { type: 'badge badge-pill badge-danger', title: '5' }
      },
      {
        id: 'bill-discount',
        title: 'Bill Discount',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-clipboard',
        url: '/trackpayout/bill-discount',
      },
      {
        id: 'statutory',
        title: 'Statutory',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-clipboard',
        children: [
          {
            id: 'msme',
            title: 'MSME',
            type: 'item',
            url: '/trackpayout/administrator/statutory/msme',
          },
          {
            id: 'gst',
            title: 'GST',
            type: 'item',
            url: '/trackpayout/administrator/statutory/gst',
          }
        ]
      },
      {
        id: 'administrator',
        title: 'Administrator',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-settings',
        children: [
          {
            id: 'acmanager',
            title: 'Account Manager',
            type: 'item',
            url: '/trackpayout/administrator/acmanager',
          },
          {
            id: 'bankdetails',
            title: 'Bank Details',
            type: 'item',
            url: '/trackpayout/administrator/bankdetails',
          },
          {
            id: 'category',
            title: 'Category',
            type: 'item',
            url: '/trackpayout/administrator/category',
          },
          {
            id: 'company',
            title: 'Company',
            type: 'item',
            url: '/trackpayout/administrator/company',
          },
          {
            id: 'customer',
            title: 'Customer',
            type: 'item',
            url: '/trackpayout/administrator/customer',
          },
          {
            id: 'user',
            title: 'User',
            type: 'item',
            url: '/trackpayout/administrator/user',
          },
          {
            id: 'enablenotification',
            title: 'Enable Notification',
            type: 'item',
            url: '/trackpayout/administrator/enablenotification',
          },
        ]
      },
      {
        id: 'log',
        title: 'Log',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-clipboard',
        children: [
          {
            id: 'alllog',
            title: 'Logs',
            type: 'item',
            url: '/trackpayout/log/all',
          },
          {
            id: 'logbyuser',
            title: 'Logs by User',
            type: 'item',
            url: '/trackpayout/log/byuser',
          },
        ]
      },
    ]
  },
];

const NavigationItemsNonAdmin = [
  {
    id: 'trackpayout',
    // title: 'Trackpayout',
    type: 'group',
    icon: 'feather icon-monitor',
    children: [
      {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-home',
        children: [
          {
            id: 'standard',
            title: 'Standard',
            type: 'item',
            url: '/trackpayout/dashboard/standard',
          },
          {
            id: 'amount',
            title: 'By Amount',
            type: 'item',
            url: '/trackpayout/dashboard/amount',
          },
          {
            id: 'invoices',
            title: 'By Invoices',
            type: 'item',
            url: '/trackpayout/dashboard/invoice',
          }, {
            id: 'Outstanding Summary',
            title: 'Outstanding Summary',
            type: 'item',
            url: '/trackpayout/OutstandingReport',
          },
        ]
      },
      {
        id: 'invoice',
        title: 'Invoice',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-plus',
        url: '/trackpayout/invoice/create',
      },
      {
        id: 'report',
        title: 'Report',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-file-text',
        children: [
          // {
          //   id: 'statement',
          //   title: 'Ledger Statement',
          //   type: 'item',
          //   url: '/trackpayout/report/statement',
          // },
          {
            id: 'all',
            title: 'All Invoices',
            type: 'item',
            url: '/trackpayout/report/all',
          },
          {
            id: 'indue',
            title: 'Due Invoices',
            type: 'item',
            url: '/trackpayout/report/indue',
          },
          {
            id: 'overdue',
            title: 'Overdue Invoices',
            type: 'item',
            url: '/trackpayout/report/overdue',
          },
          {
            id: 'paid',
            title: 'Paid Invoices',
            type: 'item',
            url: '/trackpayout/report/paid',
          },
          {
            id: 'unpaid',
            title: 'Unpaid Invoices',
            type: 'item',
            url: '/trackpayout/report/unpaid',
          },
          {
            id: 'byduedays',
            title: 'By Due Days',
            type: 'collapse',
            classes: 'nav-item',
            children: [
              {
                id: 'todays',
                // tslint:disable-next-line: quotemark
                title: "Today's Payment",
                type: 'item',
                url: '/trackpayout/report/byduedays/todays',
              },
              {
                id: '7days',
                title: '7 Days',
                type: 'item',
                url: '/trackpayout/report/byduedays/7',
              },
              {
                id: '15days',
                title: '15 Days',
                type: 'item',
                url: '/trackpayout/report/byduedays/15',
              },
              {
                id: '30days',
                title: '30 Days',
                type: 'item',
                url: '/trackpayout/report/byduedays/30',
              },
              {
                id: '60days',
                title: '60 Days',
                type: 'item',
                url: '/trackpayout/report/byduedays/60',
              },
              {
                id: '90days',
                title: '90 Days',
                type: 'item',
                url: '/trackpayout/report/byduedays/90',
              },
              {
                id: 'toofar',
                title: 'Too Far',
                type: 'item',
                url: '/trackpayout/report/byduedays/toofar',
              },
            ]
          },
          {
            id: 'bymasters',
            title: 'By Masters',
            type: 'collapse',
            classes: 'nav-item',
            children: [
              {
                id: 'acmanager',
                // tslint:disable-next-line: quotemark
                title: "By Account Manager",
                type: 'item',
                url: '/trackpayout/report/bymasters/acmanager',
              },
              {
                id: 'category',
                title: 'By Category',
                type: 'item',
                url: '/trackpayout/report/bymasters/category',
              },
              {
                id: 'customer',
                title: 'By Customer',
                type: 'item',
                url: '/trackpayout/report/bymasters/customer',
              },
              {
                id: 'location',
                title: 'By Location',
                type: 'item',
                url: '/trackpayout/report/bymasters/location',
              },
            ]
          },
          {
            id: 'ageing',
            title: 'Ageing Reports',
            type: 'item',
            url: '/trackpayout/report/ageing',
          }
        ]
      },
      {
        id: 'log',
        title: 'Log',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-clipboard',
        children: [
          {
            id: 'alllog',
            title: 'Logs',
            type: 'item',
            url: '/trackpayout/log/all',
          },
        ]
      },
    ]
  },
];

const NavigationItemsAdminTallyContisoftPannel = [
  {
    id: 'trackpayout',
    // title: 'Trackpayout',
    type: 'group',
    icon: 'feather icon-monitor',
    children: [
      {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-home',
        children: [
          {
            id: 'standard',
            title: 'Standard',
            type: 'item',
            url: '/trackpayout/dashboard/standard',
          },
          {
            id: 'amount',
            title: 'By Amount',
            type: 'item',
            url: '/trackpayout/dashboard/amount',
          },
          {
            id: 'ledger',
            title: 'By Ledger',
            type: 'item',
            url: '/trackpayout/dashboard/ledger',
          }, {
            id: 'Outstanding Summary',
            title: 'Outstanding Summary',
            type: 'item',
            url: '/trackpayout/OutstandingReport',
          },
          // {
          //   id: 'invoices',
          //   title: 'By Invoices',
          //   type: 'item',
          //   url: '/trackpayout/dashboard/invoice',
          // },
          // {
          //   id: 'analysis-report',
          //   title: 'Analysis Report',
          //   type: 'item',
          //   url: '/trackpayout/dashboard/analysis-report',
          // },
        ]
      },

      // {
      //   id: 'invoice',
      //   title: 'Invoice',
      //   type: 'item',
      //   classes: 'nav-item',
      //   icon: 'feather icon-plus',
      //   url: '/trackpayout/invoice/create',
      // },
      // {
      //   id: 'push-invoice',
      //   title: 'Invoice Submission',
      //   type: 'item',
      //   classes: 'nav-item',
      //   icon: 'feather icon-thumbs-up',
      //   url: '/trackpayout/pushinvoice',
      // },
      {
        id: 'manual',
        title: 'Manual',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-plus',
        children: [
          {
            id: 'ledger',
            title: 'Ledger',
            type: 'item',
            url: '/trackpayout/manual/ledger',
            breadcrumbs: true
          },
          {
            id: 'sale_invoice',
            title: 'Sale Invoices',
            type: 'item',
            url: '/trackpayout/manual/sale_invoices',
            breadcrumbs: true
          },
          {
            id: 'item_master',
            title: 'Stock Items',
            type: 'item',
            url: '/trackpayout/manual/item_master',
            breadcrumbs: true
          },
          // {
          //   id: 'unit_master',
          //   title: 'Measurement Unit',
          //   type: 'item',
          //   url: '/trackpayout/manual/unit_master',
          //   breadcrumbs: true
          // },
          {
            id: 'unit_master',
            title: 'Update Payment',
            type: 'item',
            url: '/trackpayout/manual/update-payment',
            breadcrumbs: true
          },
        ]
      },
      {
        id: 'ageing',
        title: 'Ageing Report',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-clock',
        url: '/trackpayout/report/ageing',
      },
      {
        id: 'report',
        title: 'Reports',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-file-text',
        children: [
          // {
          //   id: 'groups-tally',
          //   title: 'Group Oustanding',
          //   type: 'item',
          //   url: '/trackpayout/report-tally/groups-tally',
          // },
          // {
          //   id: 'ledger-tally',
          //   title: 'Ledger Statement',
          //   type: 'collapse',
          //   classes: 'nav-item',
          //   children: [
          //     {
          //       id: 'sundry-debtor',
          //       // tslint:disable-next-line: quotemark
          //       title: "Sundry Debtor",
          //       type: 'item',
          //       url: '/trackpayout/report-tally/ledger-tally/sundry-debtor',
          //     },
          //     {
          //       id: 'sundry-creditor',
          //       // tslint:disable-next-line: quotemark
          //       title: "Sundry Creditor",
          //       type: 'item',
          //       url: '/trackpayout/report-tally/ledger-tally/sundry-creditor',
          //     },
          //   ]
          // },
          {
            id: 'byduedays-tally',
            title: 'By Due Days',
            type: 'collapse',
            classes: 'nav-item',
            children: [
              {
                id: 'sundry-debtor-duedays',
                // tslint:disable-next-line: quotemark
                title: "Sundry Debtor",
                type: 'item',
                url: '/trackpayout/report-tally/byduedays-tally/sundry-debtor-duedays',
              },
              {
                id: 'sundry-creditor-duedays',
                // tslint:disable-next-line: quotemark
                title: "Sundry Creditor",
                type: 'item',
                url: '/trackpayout/report-tally/byduedays-tally/sundry-creditor-duedays',
              },
            ]
          },
          {
            id: 'bill-tally',
            title: 'Bills Report',
            type: 'item',
            url: '/trackpayout/report-tally/bill-tally',
          },
          // {
          //   id: 'post-date',
          //   title: 'Post Dated Report',
          //   type: 'item',
          //   url: '/trackpayout/report-tally/post-date',
          // },
          {
            id: 'sale-tally',
            title: 'Sale Registor',
            type: 'item',
            url: '/trackpayout/report-tally/sale-tally',
          },
          {
            id: 'receipt-tally',
            title: 'Receipt Registor',
            type: 'item',
            url: '/trackpayout/report-tally/receipt-tally',
          },
          // {
          //   id: 'creditnote-tally',
          //   title: 'Credit Note Registor',
          //   type: 'item',
          //   url: '/trackpayout/report-tally/creditnote-tally',
          // },
          // {
          //   id: 'purchase-tally',
          //   title: 'Purchase Registor',
          //   type: 'item',
          //   url: '/trackpayout/report-tally/purchase-tally',
          // },
          // {
          //   id: 'payment-tally',
          //   title: 'Payment Registor',
          //   type: 'item',
          //   url: '/trackpayout/report-tally/payment-tally',
          // },
          // {
          //   id: 'debitnote-tally',
          //   title: 'Debit Note Registor',
          //   type: 'item',
          //   url: '/trackpayout/report-tally/debitnote-tally',
          // },
          // {
          //   id: 'journal-tally',
          //   title: 'Journal Registor',
          //   type: 'item',
          //   url: '/trackpayout/report-tally/journal-tally',
          // },
          // {
          //   id: 'unpaid-tally',
          //   title: 'Unpaid Sales Invoice',
          //   type: 'item',
          //   url: '/trackpayout/report-tally/unpaid-tally',
          // },
        ]
      },
      // {
      //   id: 'ageing',
      //   title: 'Ageing Report',
      //   type: 'item',
      //   classes: 'nav-item',
      //   icon: 'feather icon-clock',
      //   url: '/trackpayout/report/ageing',
      // },
      // {
      //   id: 'reminder',
      //   title: 'Reminder',
      //   type: 'item',
      //   classes: 'nav-item',
      //   icon: 'feather icon-bell-off',
      //   url: '/trackpayout/reminder',
      // },
      {
        id: 'followup',
        title: 'Mail Follow Up',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-mail',
        url: '/trackpayout/followup',
      },
      {
        id: 'invoicefollowup',
        title: 'Follow Up Module',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-clock',
        url: '/trackpayout/InvoiceFollowup',
      },
      {
        id: 'clinets-performance',
        title: 'Clients Performance',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-activity',
        url: '/trackpayout/clients',
      },
      {
        id: 'task',
        title: 'Task',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-clock',
        url: '/trackpayout/task',
        badge: { type: 'badge badge-pill badge-danger', title: '5' }
      },
      {
        id: 'bill-discount',
        title: 'Bill Discount',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-clipboard',
        url: '/trackpayout/bill-discount',
      },
      {
        id: 'statutory',
        title: 'Statutory',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-clipboard',
        children: [
          {
            id: 'msme',
            title: 'MSME',
            type: 'item',
            url: '/trackpayout/administrator/statutory/msme',
          },
          {
            id: 'gst',
            title: 'GST',
            type: 'item',
            url: '/trackpayout/administrator/statutory/gst',
          }
        ]
      },
      // {
      //   id: 'crm',
      //   title: 'CRM',
      //   type: 'collapse',
      //   classes: 'nav-item',
      //   icon: 'feather icon-clipboard',
      //   children: [
      //     {
      //       id: 'lead',
      //       title: 'Leads',
      //       type: 'item',
      //       url: '/trackpayout/lead/leadview'
      //     },
      //     {
      //       id: 'quotations',
      //       title: 'Quotations',
      //       type: 'item',
      //       url: '/trackpayout/lead/quote'
      //     }
      //   ]
      // },
      {
        id: 'contisoftpannel',
        title: 'Contisoft Pannel',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-clipboard',
        children: [
          {
            id: 'dashboard',
            title: 'Dashboard',
            type: 'item',
            url: '/trackpayout/contisoftpannel/dashboard',
          },
          {
            id: 'subscriptions',
            title: 'Subscriptions',
            type: 'item',
            url: '/trackpayout/contisoftpannel/customer',
          },
          {
            id: 'companies',
            title: 'Companies',
            type: 'item',
            url: '/trackpayout/contisoftpannel/company',
          },
        ]
      },
      {
        id: 'administrator',
        title: 'Administrator',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-settings',
        children: [
          {
            id: 'user-tally',
            title: 'User',
            type: 'item',
            url: '/trackpayout/administrator-tally/user-tally',
          },
          {
            id: 'ledger-tally',
            title: 'Ledger',
            type: 'item',
            url: '/trackpayout/administrator-tally/ledger-tally',
          },
          // {
          //   id: 'vendors',
          //   title: 'OnBoard Masters',
          //   type: 'item',
          //   url: '/trackpayout/administrator-tally/vendors-tally',
          // },
          // {
          //   id: 'bankdetails',
          //   title: 'Bank Details',
          //   type: 'item',
          //   url: '/trackpayout/administrator-tally/bankdetails-tally',
          // },
          {
            id: 'company',
            title: 'Company',
            type: 'item',
            url: '/trackpayout/administrator-tally/company-tally',
          },
          {
            id: 'saleperson',
            title: 'Sales Executive',
            type: 'item',
            url: '/trackpayout/administrator-tally/salesperson',
          },
        ]
      },
      {
        id: 'log',
        title: 'Log',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-clipboard',
        children: [
          {
            id: 'alllog',
            title: 'Logs',
            type: 'item',
            url: '/trackpayout/log/all',
          },
          {
            id: 'logbyuser',
            title: 'Logs by User',
            type: 'item',
            url: '/trackpayout/log/byuser',
          },
        ]
      },
    ]
  },
];

const NavigationItemsAdminTally = [
  {
    id: 'trackpayout',
    // title: 'Trackpayout',
    type: 'group',
    icon: 'feather icon-monitor',
    children: [
      {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-home',
        children: [
          {
            id: 'standard',
            title: 'Standard',
            type: 'item',
            url: '/trackpayout/dashboard/standard',

          },
          {
            id: 'amount',
            title: 'By Amount',
            type: 'item',
            url: '/trackpayout/dashboard/amount',
          },
          {
            id: 'ledger',
            title: 'By Ledger',
            type: 'item',
            url: '/trackpayout/dashboard/ledger',
            breadcrumbs: true
          }, {
            id: 'Outstanding Summary',
            title: 'Outstanding Summary',
            type: 'item',
            url: '/trackpayout/OutstandingReport',
          },
          // {
          //   id: 'invoices',
          //   title: 'By Invoices',
          //   type: 'item',
          //   url: '/trackpayout/dashboard/invoice',
          // },
          // {
          //   id: 'analysis-report',
          //   title: 'Analysis Report',
          //   type: 'item',
          //   url: '/trackpayout/dashboard/analysis-report',
          // },
        ]
      },
      // {
      //   id: 'invoice',
      //   title: 'Invoice',
      //   type: 'item',
      //   classes: 'nav-item',
      //   icon: 'feather icon-plus',
      //   url: '/trackpayout/invoice/create',
      // },
      // {
      //   id: 'push-invoice',
      //   title: 'Invoice Submission',
      //   type: 'item',
      //   classes: 'nav-item',
      //   icon: 'feather icon-thumbs-up',
      //   url: '/trackpayout/pushinvoice',
      // },
      {
        id: 'manual',
        title: 'Manual',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-plus',
        children: [
          {
            id: 'ledger',
            title: 'Ledger',
            type: 'item',
            url: '/trackpayout/manual/ledger',
            breadcrumbs: true
          },
          {
            id: 'sale_invoice',
            title: 'Sale Invoices',
            type: 'item',
            url: '/trackpayout/manual/sale_invoices',
            breadcrumbs: true
          },
          {
            id: 'item_master',
            title: 'Stock Items',
            type: 'item',
            url: '/trackpayout/manual/item_master',
            breadcrumbs: true
          },
          // {
          //   id: 'unit_master',
          //   title: 'Measurement Unit',
          //   type: 'item',
          //   url: '/trackpayout/manual/unit_master',
          //   breadcrumbs: true
          // },
          {
            id: 'unit_master',
            title: 'Update Payment',
            type: 'item',
            url: '/trackpayout/manual/update-payment',
            breadcrumbs: true
          },
        ]
      },
      {
        id: 'ageing',
        title: 'Ageing Report',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-clock',
        url: '/trackpayout/report/ageing',
      },
      {
        id: 'report',
        title: 'Reports',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-file-text',
        children: [
          // {
          //   id: 'groups-tally',
          //   title: 'Group Oustanding',
          //   type: 'item',
          //   url: '/trackpayout/report-tally/groups-tally',
          // },
          // {
          //   id: 'ledger-tally',
          //   title: 'Ledger Statement',
          //   type: 'collapse',
          //   classes: 'nav-item',
          //   children: [
          //     {
          //       id: 'sundry-debtor',
          //       // tslint:disable-next-line: quotemark
          //       title: "Sundry Debtor",
          //       type: 'item',
          //       url: '/trackpayout/report-tally/ledger-tally/sundry-debtor',
          //     },
          //     {
          //       id: 'sundry-creditor',
          //       // tslint:disable-next-line: quotemark
          //       title: "Sundry Creditor",
          //       type: 'item',
          //       url: '/trackpayout/report-tally/ledger-tally/sundry-creditor',
          //     },
          //   ]
          // },
          {
            id: 'byduedays-tally',
            title: 'By Due Days',
            type: 'collapse',
            classes: 'nav-item',
            children: [
              {
                id: 'sundry-debtor-duedays',
                // tslint:disable-next-line: quotemark
                title: "Sundry Debtor",
                type: 'item',
                url: '/trackpayout/report-tally/byduedays-tally/sundry-debtor-duedays',
              },
              {
                id: 'sundry-creditor-duedays',
                // tslint:disable-next-line: quotemark
                title: "Sundry Creditor",
                type: 'item',
                url: '/trackpayout/report-tally/byduedays-tally/sundry-creditor-duedays',
              },
            ]
          },
          {
            id: 'bill-tally',
            title: 'Bills Report',
            type: 'item',
            url: '/trackpayout/report-tally/bill-tally',
          },
          {
            id: 'post-date',
            title: 'Post Dated Report',
            type: 'item',
            url: '/trackpayout/report-tally/post-date',
          },
          {
            id: 'sale-tally',
            title: 'Sale Register',
            type: 'item',
            url: '/trackpayout/report-tally/sale-tally',
          },
          {
            id: 'receipt-tally',
            title: 'Receipt Register',
            type: 'item',
            url: '/trackpayout/report-tally/receipt-tally',
          },
          // {
          //   id: 'creditnote-tally',
          //   title: 'Credit Note Register',
          //   type: 'item',
          //   url: '/trackpayout/report-tally/creditnote-tally',
          // },
          // {
          //   id: 'purchase-tally',
          //   title: 'Purchase Register',
          //   type: 'item',
          //   url: '/trackpayout/report-tally/purchase-tally',
          // },
          // {
          //   id: 'payment-tally',
          //   title: 'Payment Register',
          //   type: 'item',
          //   url: '/trackpayout/report-tally/payment-tally',
          // },
          // {
          //   id: 'debitnote-tally',
          //   title: 'Debit Note Register',
          //   type: 'item',
          //   url: '/trackpayout/report-tally/debitnote-tally',
          // },
          // {
          //   id: 'journal-tally',
          //   title: 'Journal Register',
          //   type: 'item',
          //   url: '/trackpayout/report-tally/journal-tally',
          // },
          // {
          //   id: 'unpaid-tally',
          //   title: 'Unpaid Sales Invoice',
          //   type: 'item',
          //   url: '/trackpayout/report-tally/unpaid-tally',
          // },
        ]
      },
      // {
      //   id: 'ageing',
      //   title: 'Ageing Report',
      //   type: 'item',
      //   classes: 'nav-item',
      //   icon: 'feather icon-clock',
      //   url: '/trackpayout/report/ageing',
      // },
      // {
      //   id: 'reminder',
      //   title: 'Reminder',
      //   type: 'item',
      //   classes: 'nav-item',
      //   icon: 'feather icon-bell-off',
      //   url: '/trackpayout/reminder',
      // },
      {
        id: 'followup',
        title: 'Mail Follow Up',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-mail',
        url: '/trackpayout/followup',
      },
      {
        id: 'invoicefollowup',
        title: 'Follow Up Module',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-clock',
        url: '/trackpayout/InvoiceFollowup',
      },
      {
        id: 'clinets-performance',
        title: 'Clients Performance',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-activity',
        url: '/trackpayout/clients',
      },
      {
        id: 'task',
        title: 'Task',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-clock',
        url: '/trackpayout/task',
        badge: { type: 'badge badge-pill badge-danger', title: '5' }
      },
      {
        id: 'bill-discount',
        title: 'Bill Discount',
        type: 'item',
        classes: 'nav-item',
        icon: 'feather icon-clipboard',
        url: '/trackpayout/bill-discount',
      },
      {
        id: 'statutory',
        title: 'Statutory',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-clipboard',
        children: [
          {
            id: 'msme',
            title: 'MSME',
            type: 'item',
            url: '/trackpayout/administrator/statutory/msme',
          },
          {
            id: 'gst',
            title: 'GST',
            type: 'item',
            url: '/trackpayout/administrator/statutory/gst',
          }
        ]
      },
      // {
      //   id: 'crm',
      //   title: 'CRM',
      //   type: 'collapse',
      //   classes: 'nav-item',
      //   icon: 'feather icon-clipboard',
      //   children: [
      //     {
      //       id: 'lead',
      //       title: 'Leads',
      //       type: 'item',
      //       url: '/trackpayout/lead/leadview'
      //     },
      //     {
      //       id: 'quotations',
      //       title: 'Quotations',
      //       type: 'item',
      //       url: '/trackpayout/lead/quote'
      //     }
      //   ]
      // },
      {
        id: 'administrator',
        title: 'Administrator',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-settings',
        children: [
          {
            id: 'user-tally',
            title: 'User',
            type: 'item',
            url: '/trackpayout/administrator-tally/user-tally',
          },
          {
            id: 'ledger-tally',
            title: 'Ledger',
            type: 'item',
            url: '/trackpayout/administrator-tally/ledger-tally',
          },
          {
            id: 'bankdetails',
            title: 'Bank Details',
            type: 'item',
            url: '/trackpayout/administrator-tally/bankdetails-tally',
          },
          // {
          //   id: 'vendors',
          //   title: 'OnBoard Masters',
          //   type: 'item',
          //   url: '/trackpayout/administrator-tally/vendors-tally',
          // },

          {
            id: 'company',
            title: 'Company',
            type: 'item',
            url: '/trackpayout/administrator-tally/company-tally',
          },
          // {
          //   id: 'quickbooks',
          //   title: 'Quickbooks',
          //   type: 'item',
          //   classes: 'nav-item',
          //   // icon: 'feather icon-clock',
          //   url: '/quickbooks/quickbooks-config',
          // },
          {
            id: 'salesperson',
            title: 'Sales Executive',
            type: 'item',
            url: '/trackpayout/administrator-tally/salesperson',
          },
        ]
      },
      {
        id: 'log',
        title: 'Log',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-clipboard',
        children: [
          {
            id: 'alllog',
            title: 'Logs',
            type: 'item',
            url: '/trackpayout/log/all',
          },
          {
            id: 'logbyuser',
            title: 'Logs by User',
            type: 'item',
            url: '/trackpayout/log/byuser',
          },
        ]
      },
    ]
  },
];

const NavigationItemsNonAdminTally = [
  {
    id: 'trackpayout',
    // title: 'Trackpayout',
    type: 'group',
    icon: 'feather icon-monitor',
    children: [
      {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-home',
        children: [
          {
            id: 'standard',
            title: 'Standard',
            type: 'item',
            url: '/trackpayout/dashboard/standard',
          },
          {
            id: 'amount',
            title: 'By Amount',
            type: 'item',
            url: '/trackpayout/dashboard/amount',
          },
          {
            id: 'ledger',
            title: 'By Ledger',
            type: 'item',
            url: '/trackpayout/dashboard/ledger',
          }, {
            id: 'Outstanding Summary',
            title: 'Outstanding Summary',
            type: 'item',
            url: '/trackpayout/OutstandingReport',
          },
          // {
          //   id: 'invoices',
          //   title: 'By Invoices',
          //   type: 'item',
          //   url: '/trackpayout/dashboard/invoice',
          // }
        ]
      },
      // {
      //   id: 'invoice',
      //   title: 'Invoice',
      //   type: 'item',
      //   classes: 'nav-item',
      //   icon: 'feather icon-plus',
      //   url: '/trackpayout/invoice/create',
      // },
      {
        id: 'manual',
        title: 'Manual',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-plus',
        children: [
          {
            id: 'ledger',
            title: 'Ledger',
            type: 'item',
            url: '/trackpayout/manual/ledger',
            breadcrumbs: true
          },
          {
            id: 'sale_invoice',
            title: 'Sale Invoices',
            type: 'item',
            url: '/trackpayout/manual/sale_invoices',
            breadcrumbs: true
          },
          {
            id: 'item_master',
            title: 'Stock Items',
            type: 'item',
            url: '/trackpayout/manual/item_master',
            breadcrumbs: true
          },
          // {
          //   id: 'unit_master',
          //   title: 'Measurement Unit',
          //   type: 'item',
          //   url: '/trackpayout/manual/unit_master',
          //   breadcrumbs: true
          // },
          {
            id: 'unit_master',
            title: 'Update Payment',
            type: 'item',
            url: '/trackpayout/manual/update-payment',
            breadcrumbs: true
          },
        ]
      },
      {
        id: 'report',
        title: 'Report',
        type: 'expand',
        classes: 'nav-item',
        icon: 'feather icon-file-text',
        children: [
          // {
          //   id: 'ledger-tally',
          //   title: 'Ledger Statement',
          //   type: 'collapse',
          //   classes: 'nav-item',
          //   children: [
          //     {
          //       id: 'sundry-debtor',
          //       // tslint:disable-next-line: quotemark
          //       title: "Sundry Debtor",
          //       type: 'item',
          //       url: '/trackpayout/report-tally/ledger-tally/sundry-debtor',
          //     },
          //     {
          //       id: 'sundry-creditor',
          //       // tslint:disable-next-line: quotemark
          //       title: "Sundry Creditor",
          //       type: 'item',
          //       url: '/trackpayout/report-tally/ledger-tally/sundry-creditor',
          //     },
          //   ]
          // },
          {
            id: 'byduedays-tally',
            title: 'By Due Days',
            type: 'collapse',
            classes: 'nav-item',
            children: [
              {
                id: 'sundry-debtor-duedays',
                // tslint:disable-next-line: quotemark
                title: "Sundry Debtor",
                type: 'item',
                url: '/trackpayout/report-tally/byduedays-tally/sundry-debtor-duedays',
              },
              {
                id: 'sundry-creditor-duedays',
                // tslint:disable-next-line: quotemark
                title: "Sundry Creditor",
                type: 'item',
                url: '/trackpayout/report-tally/byduedays-tally/sundry-creditor-duedays',
              },
            ]
          },
          {
            id: 'bill-tally',
            title: 'Bills Report',
            type: 'item',
            url: '/trackpayout/report-tally/bill-tally',
          },
          // {
          //   id: 'post-date',
          //   title: 'Post Dated Report',
          //   type: 'item',
          //   url: '/trackpayout/report-tally/post-date',
          // },
          {
            id: 'sale-tally',
            title: 'Sale Register',
            type: 'item',
            url: '/trackpayout/report-tally/sale-tally',
          },
          {
            id: 'receipt-tally',
            title: 'Receipt Register',
            type: 'item',
            url: '/trackpayout/report-tally/receipt-tally',
          },
          // {
          //   id: 'creditnote-tally',
          //   title: 'Credit Note Register',
          //   type: 'item',
          //   url: '/trackpayout/report-tally/creditnote-tally',
          // },
          // {
          //   id: 'purchase-tally',
          //   title: 'Purchase Register',
          //   type: 'item',
          //   url: '/trackpayout/report-tally/purchase-tally',
          // },
          // {
          //   id: 'payment-tally',
          //   title: 'Payment Register',
          //   type: 'item',
          //   url: '/trackpayout/report-tally/payment-tally',
          // },
          // {
          //   id: 'debitnote-tally',
          //   title: 'Debit Note Register',
          //   type: 'item',
          //   url: '/trackpayout/report-tally/debitnote-tally',
          // },
          // {
          //   id: 'journal-tally',
          //   title: 'Journal Register',
          //   type: 'item',
          //   url: '/trackpayout/report-tally/journal-tally',
          // },
          // {
          //   id: 'unpaid-tally',
          //   title: 'Unpaid Sales Invoice',
          //   type: 'item',
          //   url: '/trackpayout/report-tally/unpaid-tally',
          // },
        ]
      },
      {
        id: 'log',
        title: 'Log',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-clipboard',
        children: [
          {
            id: 'alllog',
            title: 'Logs',
            type: 'item',
            url: '/trackpayout/log/all',
          },
        ]
      },
    ]
  },
]

@Injectable()
export class NavigationItem {
  public getContisoftAdmin() {
    return NavigationItemsContisoftPannel;
  }
  public getAdmin() {
    return NavigationItemsAdmin;
  }
  public getNonAdmin() {
    return NavigationItemsNonAdmin;
  }
  public getAdminTally() {
    return NavigationItemsAdminTally;
  }
  public getNonAdminTally() {
    return NavigationItemsNonAdminTally;
  }
  public getConstisoftAdminTally() {
    return NavigationItemsAdminTallyContisoftPannel
  }
}
